import { GlIcon } from '@gitlab/ui';
export default {
    name: 'HelpIcon',
    components: {
        GlIcon
    }
};
